export const categories = [
  { id: "all", name: "全部", slug: "all", description: "浏览全部漫画资源", icon: "ri-apps-2-line" },
  { id: "romance", name: "恋爱言情", slug: "romance", description: "甜蜜浪漫的恋爱故事", icon: "ri-heart-line" },
  { id: "fantasy", name: "奇幻冒险", slug: "fantasy", description: "异世界奇幻冒险之旅", icon: "ri-rocket-line" },
  { id: "urban", name: "都市生活", slug: "urban", description: "现代都市情感故事", icon: "ri-building-line" },
  { id: "suspense", name: "悬疑推理", slug: "suspense", description: "扣人心弦的悬疑剧情", icon: "ri-search-eye-line" },
  { id: "comedy", name: "轻松搞笑", slug: "comedy", description: "欢乐搞笑的日常漫画", icon: "ri-emotion-laugh-line" },
  { id: "school", name: "校园青春", slug: "school", description: "青春校园纯爱物语", icon: "ri-book-open-line" },
  { id: "historical", name: "古风雅韵", slug: "historical", description: "唯美古风历史故事", icon: "ri-book-2-line" },
];

export const comics = [
  {
    id: "1",
    title: "暗夜玫瑰",
    author: "墨染青衣",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20manga-style%20illustration%20of%20a%20beautiful%20woman%20with%20dark%20hair%20holding%20a%20red%20rose%2C%20soft%20moonlight%20background%2C%20elegant%20and%20mysterious%20atmosphere%2C%20warm%20dark%20tones%2C%20delicate%20linework%2C%20Japanese%20shoujo%20manga%20style%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    description: "在繁华都市的夜色中，一朵带刺的玫瑰悄然绽放。她美丽而危险，他温柔而执着，一段禁忌之恋在月光下缓缓展开。",
    rating: 9.2,
    views: 128000,
    chapters: 48,
    updateDate: "2026-08-10",
    tags: ["恋爱", "都市", "剧情"],
    featured: true,
    content: "<p>夜幕降临，城市的霓虹灯次第亮起。林若曦站在天台的边缘，微风拂过她的长发，带来一丝凉意。她已经很久没有这样静静地看夜景了。</p><p>「又在这里发呆？」身后传来熟悉的声音。</p><p>她没有回头，只是嘴角微微扬起：「你怎么知道我在这里？」</p><p>沈墨走到她身边，双手撑在栏杆上，目光落在远方的灯火中：「因为你每次心情不好的时候，都会来这里。」</p><p>林若曦转过头，看着身旁这个总是能看穿她心思的男人。他的侧脸在霓虹灯的映照下，显得格外深邃。</p><p>「沈墨，你说，喜欢一个人是什么感觉？」她轻声问道。</p><p>沈墨沉默了一会儿，然后转过身，认真地看着她的眼睛：「就是无论她在哪里，你都想找到她；无论她做什么，你都觉得可爱；无论发生什么，你都不想放开她的手。」</p><p>林若曦的心脏猛地跳了一下。她在他的眼睛里，看到了自己的倒影。</p><p>「那……」她的声音有些颤抖，「你喜欢我吗？」</p><p>夜风轻轻吹过，带来了远处花香。沈墨没有回答，而是俯身，在她额头上轻轻落下一吻。</p><p>这一吻，胜过千言万语。</p>",
  },
  {
    id: "2",
    title: "星海迷途",
    author: "星河漫步",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20illustration%20of%20a%20young%20adventurer%20gazing%20at%20a%20starry%20galaxy%20sky%2C%20magical%20glowing%20particles%20floating%20around%2C%20mysterious%20and%20dreamy%20atmosphere%2C%20deep%20blue%20and%20purple%20cosmic%20background%2C%20anime%20art%20style%2C%20detailed%20character%20design&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    description: "当她睁开眼时，发现自己身处一个完全陌生的星际世界。为了回到地球，她必须在这片星海中找到传说中的时空之门。",
    rating: 8.9,
    views: 95000,
    chapters: 36,
    updateDate: "2026-08-09",
    tags: ["奇幻", "冒险", "异世界"],
    featured: true,
    content: "<p>苏晴睁开眼的瞬间，刺目的光芒让她下意识地抬手遮挡。</p><p>当眼睛逐渐适应光线后，她整个人都僵住了——头顶不是熟悉的天花板，而是一片绚烂的星海。无数星辰在深蓝色的天幕中闪烁，仿佛触手可及。</p><p>「这是……什么地方？」她喃喃自语。</p><p>「欢迎来到星域。」一个清冷的声音从身后传来。</p><p>苏晴猛地转身，看到一个身着银色长袍的少年。他有着一头银白色的长发，瞳孔是罕见的紫金色，整个人散发出一种不食人间烟火的气质。</p><p>「你是谁？这是什么地方？我怎么回去？」苏晴一连串地问道。</p><p>少年微微挑眉：「我叫辰渊。这里是星域第七层。至于怎么回去——」他顿了顿，「你需要找到时空之门。」</p><p>「时空之门在哪里？」</p><p>「没有人知道确切的答案。」辰渊的目光落在远方，「据说它藏在星海的最深处，只有被选中的人才能找到。」</p><p>苏晴深吸一口气。好吧，既然暂时回不去，那就先弄清楚这个世界到底是怎么回事。</p><p>「你能帮我吗？」她问。</p><p>辰渊看着她，那双紫金色的眼眸中闪过一丝难以察觉的笑意：「可以。不过，你得答应我一个条件。」</p>",
  },
  {
    id: "3",
    title: "办公室密语",
    author: "指尖流年",
    category: "urban",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20office%20romance%20manga%20illustration%2C%20stylish%20businesswoman%20and%20handsome%20colleague%20sharing%20a%20quiet%20moment%20near%20a%20window%2C%20city%20skyline%20visible%20through%20glass%2C%20warm%20sunset%20lighting%2C%20elegant%20and%20sophisticated%20atmosphere%2C%20josei%20manga%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    description: "办公室里的暧昧总是最让人心跳加速。她是新来的实习生，他是公司的王牌总监，一段甜蜜又刺激的办公室恋情悄然展开。",
    rating: 9.0,
    views: 156000,
    chapters: 52,
    updateDate: "2026-08-10",
    tags: ["都市", "职场", "恋爱"],
    featured: true,
    content: "<p>第一天上班，顾小满就迟到了。</p><p>当她气喘吁吁地冲进公司大门时，正好撞上了一个结实的胸膛。手中的咖啡杯应声而落，深褐色的液体溅了对方一身。</p><p>「对、对不起！」顾小满慌乱地抬起头，然后整个人都愣住了。</p><p>面前的男人穿着一件剪裁考究的白衬衫，此刻上面已经布满了咖啡渍。但他的表情却异常平静，只是微微蹙了蹙眉，那双深邃的眼眸看向她。</p><p>「新来的？」他的声音低沉而有磁性。</p><p>「是、是的……我是顾小满，今天第一天报到。」</p><p>「第一天就给我送咖啡？」男人的嘴角微微上扬，「我是陆景琛，你的直属上司。」</p><p>顾小满只觉得眼前一黑。第一天上班，她把咖啡泼在了总监身上。这简直是她人生中最大的社死现场。</p><p>「跟我来。」陆景琛转身朝办公室走去。</p><p>顾小满忐忑不安地跟在后面，心里已经把各种可能性都想了一遍。然而当她走进办公室时，陆景琛只是递给她一条干净的毛巾。</p><p>「帮我擦一下。」他说。</p><p>「啊？」</p><p>「你泼的，你负责。」陆景琛的眼中闪过一丝促狭的笑意。</p><p>顾小满的脸瞬间红到了耳根。</p>",
  },
  {
    id: "4",
    title: "迷雾之城",
    author: "暗夜行者",
    category: "suspense",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20detective%20manga%20illustration%2C%20a%20shadowy%20figure%20standing%20in%20a%20foggy%20alley%20at%20night%2C%20dim%20streetlamp%20casting%20long%20shadows%2C%20noir%20atmosphere%2C%20dark%20and%20intriguing%2C%20seinen%20manga%20style%2C%20cinematic%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    description: "一场看似普通的失踪案，却牵扯出了一座城市最深处的秘密。侦探陈默在追查真相的过程中，发现自己也深陷迷雾之中。",
    rating: 9.5,
    views: 210000,
    chapters: 64,
    updateDate: "2026-08-11",
    tags: ["悬疑", "推理", "犯罪"],
    featured: true,
    content: "<p>凌晨三点，陈默被一通电话吵醒。</p><p>「陈队，又有新的失踪案了。」电话那头，搭档小周的声音带着一丝紧张。</p><p>陈默揉了揉太阳穴，从床上坐起来：「地点。」</p><p>「城西老工业区，废弃的纺织厂。」</p><p>二十分钟后，陈默抵达了现场。废弃的纺织厂在夜色中像一头沉睡的巨兽，斑驳的墙壁上爬满了藤蔓，空气中弥漫着一股潮湿的霉味。</p><p>「什么情况？」陈默问已经到达的小周。</p><p>「第三起了。」小周翻开笔记本，「三名失踪者都是女性，年龄在25到30岁之间，最后出现的地点都在老工业区附近。」</p><p>陈默蹲下身，用手电筒照向地面。湿润的泥土上，隐约可以看到一串脚印。</p><p>「这些脚印……不像是失踪者的。」他站起身，目光变得锐利起来，「小周，把过去六个月所有失踪案的卷宗都调出来。我总觉得，这背后有更大的东西。」</p><p>就在这时，一个纤细的身影从暗处走了出来。</p><p>「陈队长，久仰大名。」女人的声音带着一丝慵懒，「我叫苏瑾，是一名记者。关于这些失踪案，我想我有一些你可能感兴趣的信息。」</p>",
  },
  {
    id: "5",
    title: "恋爱补习班",
    author: "糖果盒子",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=A%20cute%20comedy%20manga%20illustration%20of%20two%20high%20school%20students%20blushing%20while%20studying%20together%20in%20a%20classroom%2C%20cherry%20blossoms%20outside%20the%20window%2C%20light%20and%20playful%20atmosphere%2C%20warm%20spring%20colors%2C%20shoujo%20manga%20style%2C%20clean%20and%20simple%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    description: "全校第一的学霸被逼给学渣校花补课？这场补习从一开始就充满了欢乐和意外，爱情的种子在笑声中悄然发芽。",
    rating: 8.7,
    views: 89000,
    chapters: 42,
    updateDate: "2026-08-08",
    tags: ["搞笑", "校园", "恋爱"],
    featured: false,
    content: "<p>「什么？让我给她补课？」林一凡瞪大了眼睛，难以置信地看着班主任。</p><p>「没错，林一凡同学。」班主任推了推眼镜，「苏小糖同学这学期的成绩如果再没有起色，可能会有留级风险。你是全校第一，这个任务就交给你了。」</p><p>林一凡转头看向坐在教室最后一排的苏小糖。她正趴在桌上睡觉，一头乌黑的长发随意地散落在桌面上，嘴角还挂着一丝口水。</p><p>「这怎么可能……」林一凡无力地叹了口气。</p><p>下午放学后，苏小糖被叫到了图书馆。</p><p>「所以，从今天开始，你就是我的私人教师了？」苏小糖歪着头，一双大眼睛好奇地打量着林一凡。</p><p>「是补习，不是私教。」林一凡纠正道，「来，我们先从数学开始。」</p><p>苏小糖翻开课本，看了三秒钟，然后把书合上了。</p><p>「我看不懂。」她理直气壮地说。</p><p>「你还没看呢！」</p><p>「我看封面了，封面就看不懂。」</p><p>林一凡觉得自己的血压在飙升。但他没有注意到的是，苏小糖偷偷看向他时，嘴角那抹狡黠的笑意。</p>",
  },
  {
    id: "6",
    title: "樱花树下的约定",
    author: "春日和风",
    category: "school",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20school%20love%20manga%20illustration%2C%20a%20boy%20and%20girl%20standing%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20pink%20petals%20falling%20gently%2C%20school%20uniforms%2C%20spring%20sunlight%2C%20tender%20and%20sweet%20atmosphere%2C%20shoujo%20manga%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    description: "高中三年级的春天，樱花盛开。她在樱花树下写下了一个愿望，没想到第二天，愿望就以一种意想不到的方式实现了。",
    rating: 9.1,
    views: 142000,
    chapters: 38,
    updateDate: "2026-08-09",
    tags: ["校园", "青春", "纯爱"],
    featured: true,
    content: "<p>高三的最后一个春天，校园里的樱花树开得正盛。</p><p>夏晚晚站在那棵最大的樱花树下，手里攥着一张粉色的便签纸。按照学校的传统，毕业生可以在樱花树下写下自己的愿望，挂在树枝上。</p><p>她深吸一口气，在便签纸上写下了一行字：<strong>「希望能在毕业前，和喜欢的人告白。」</strong></p><p>写完最后一个字，她踮起脚尖，将便签纸系在了一根比较低的树枝上。</p><p>「写了什么？」一个声音突然在耳边响起。</p><p>夏晚晚吓得差点跳起来，转头一看，竟然是隔壁班的校草——江辰。</p><p>「没、没什么！」她慌乱地挡在便签纸前面。</p><p>江辰微微一笑：「让我猜猜。是不是……告白的事？」</p><p>夏晚晚的脸瞬间涨得通红：「你怎么知道？！」</p><p>「因为——」江辰从口袋里掏出一张一模一样的粉色便签纸，「我也写了同样的愿望。」</p><p>樱花花瓣在他们之间飘落。夏晚晚的心脏砰砰直跳，她看着江辰那双含笑的眼眸，忽然觉得，这个春天，好像有什么不一样了。</p><p>「那……」她鼓起勇气，「你要不要和我一起，实现这个愿望？」</p><p>江辰的笑容更深了：「我以为，这句话应该由我来说。」</p>",
  },
  {
    id: "7",
    title: "长安夜未央",
    author: "墨染江湖",
    category: "historical",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20historical%20Chinese%20manga%20illustration%2C%20an%20elegant%20woman%20in%20traditional%20hanfu%20dress%20standing%20in%20ancient%20Chinese%20palace%20courtyard%2C%20lanterns%20glowing%20in%20the%20night%2C%20classical%20and%20romantic%20atmosphere%2C%20watercolor%20ink%20style%2C%20delicate%20details&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    description: "大唐盛世，长安城繁华似锦。一介布衣书生与相府千金的故事，在历史的长河中荡气回肠。",
    rating: 9.3,
    views: 178000,
    chapters: 56,
    updateDate: "2026-08-10",
    tags: ["古风", "历史", "言情"],
    featured: true,
    content: "<p>长安，正月十五，上元灯节。</p><p>整座城池被万千灯火点亮，街道上人潮涌动，锣鼓喧天。沈青山穿着洗得发白的青衫，在人群中随波逐流。</p><p>他本是为了赴京赶考而来，却不想正赶上这热闹非凡的灯节。</p><p>「卖花灯咯——」</p><p>「冰糖葫芦——又甜又脆的冰糖葫芦——」</p><p>沈青山在一处猜灯谜的摊位前停下了脚步。摊主高声道：「谁若能猜出我这三道灯谜，便可获得这盏琉璃走马灯！」</p><p>那盏走马灯精美绝伦，琉璃面上绘着飞天仙女，烛光一照，流光溢彩。</p><p>沈青山微微一笑，正欲上前，却听一个清脆的声音抢先道：「我来！」</p><p>他循声看去，只见一位身着鹅黄襦裙的少女从轿中走出，面覆轻纱，只露出一双明亮的眼眸。她身后跟着四个丫鬟，排场不小。</p><p>少女三下五除二便猜出了三道灯谜，引得周围一片喝彩。</p><p>沈青山忍不住鼓掌：「姑娘好才情！」</p><p>少女转过头，目光与他对上。那一瞬间，长安城的万千灯火，都不及她眼中的那一抹笑意。</p>",
  },
  {
    id: "8",
    title: "霸总的替身新娘",
    author: "指尖流年",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20romance%20manga%20illustration%2C%20a%20handsome%20CEO%20in%20a%20black%20suit%20holding%20a%20woman%20in%20a%20wedding%20dress%2C%20luxurious%20mansion%20background%2C%20intense%20and%20passionate%20atmosphere%2C%20josei%20manga%20style%2C%20elegant%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    description: "为了救弟弟，她代替姐姐嫁给了那个传闻中冷酷无情的男人。没想到，这场无奈的婚姻，却成了她一生中最美的意外。",
    rating: 9.4,
    views: 235000,
    chapters: 72,
    updateDate: "2026-08-11",
    tags: ["恋爱", "都市", "豪门"],
    featured: true,
    content: "<p>婚礼当天，白若溪穿着不属于自己的婚纱，站在了红毯的起点。</p><p>她的姐姐白若兰在婚礼前一天逃跑了，留下了一张字条：「对不起，我不能嫁给他。若溪，帮姐姐这一次。」</p><p>白若溪别无选择。弟弟的医疗费还需要白家支付，她只能硬着头皮，代替姐姐完成这场婚礼。</p><p>红毯的尽头，站着一个身材高大的男人。他穿着一身剪裁合体的黑色西装，面容冷峻，浑身上下散发着一种生人勿近的气场。</p><p>这就是顾霆琛——顾氏集团的掌舵人，传闻中冷酷无情的商业帝王。</p><p>白若溪一步步走向他，心脏几乎要跳出胸腔。当她终于站在他面前时，顾霆琛忽然俯身，在她耳边低声道：「你不是白若兰。」</p><p>白若溪的身体瞬间僵硬。</p><p>但顾霆琛却直起身，嘴角勾起一抹意味深长的笑意：「不过，你比她更有趣。」</p><p>他牵起她的手，手指的温度透过手套传来，让白若溪的心跳漏了一拍。</p><p>「婚礼继续。」顾霆琛对神父说，语气不容置疑。</p>",
  },
  {
    id: "9",
    title: "妖狐的契约",
    author: "星河漫步",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20illustration%20of%20a%20beautiful%20fox%20spirit%20with%20nine%20tails%20in%20human%20form%2C%20traditional%20Japanese%20shrine%20background%20at%20twilight%2C%20magical%20foxfire%20glowing%2C%20mysterious%20and%20enchanting%20atmosphere%2C%20anime%20art%20style&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    description: "她在古老神社中不小心解开了千年的封印，释放出了一只九尾妖狐。从此，她的生活发生了天翻地覆的变化。",
    rating: 9.0,
    views: 167000,
    chapters: 44,
    updateDate: "2026-08-08",
    tags: ["奇幻", "妖怪", "恋爱"],
    featured: false,
    content: "<p>暑假的最后一天，林小蝶和同学们去郊外的古老神社游玩。</p><p>那座神社据说建于千年之前，平时人烟稀少，藤蔓爬满了石阶，透着一股神秘而古老的气息。</p><p>「听说这座神社里封印着一只妖怪哦！」同学小美神秘兮兮地说。</p><p>「别瞎说了，这世界上哪有妖怪。」林小蝶不以为然地摆摆手。</p><p>然而，当她独自走进神社后殿时，她注意到地上画着一个复杂的法阵。法阵的中央，放着一块晶莹剔透的玉石。</p><p>「好漂亮……」林小蝶忍不住伸手触碰那块玉石。</p><p>就在她的指尖碰到玉石的瞬间，一阵强烈的光芒从法阵中爆发出来，整个神社都开始剧烈震动。</p><p>当光芒散去，林小蝶发现面前多了一个人——确切地说，是一个长着银色狐耳和九条蓬松尾巴的男人。</p><p>他有着一张精致到不真实的面容，琥珀色的眼眸正饶有兴趣地打量着她。</p><p>「千年了。」他的声音低沉而优雅，「终于有人解开了封印。」</p><p>林小蝶吓得连连后退：「你、你是谁？！」</p><p>「我叫银月。」他微微一笑，露出尖尖的虎牙，「一只被封印了千年的九尾妖狐。而你——」他凑近她的脸，「现在是我的契约者了。」</p>",
  },
  {
    id: "10",
    title: "闺蜜的秘密",
    author: "糖果盒子",
    category: "urban",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20friendship%20manga%20illustration%2C%20two%20young%20women%20having%20an%20intense%20conversation%20in%20a%20cozy%20cafe%2C%20rain%20outside%20the%20window%2C%20emotional%20and%20heartfelt%20atmosphere%2C%20warm%20interior%20lighting%2C%20josei%20manga%20style&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    description: "三个从小一起长大的闺蜜，各自有着不为人知的秘密。当这些秘密逐一浮出水面，她们的友谊将面临前所未有的考验。",
    rating: 8.8,
    views: 103000,
    chapters: 30,
    updateDate: "2026-08-07",
    tags: ["都市", "友情", "情感"],
    featured: false,
    content: "<p>周末的下午，咖啡馆里弥漫着咖啡豆的香气。</p><p>苏小曼搅动着杯中的拿铁，目光在两位好友之间游移。林雨晴正在兴致勃勃地讲她和新男友的甜蜜故事，而赵晓柔则低着头，一言不发地刷着手机。</p><p>「……然后他就单膝跪地，从口袋里掏出了——」林雨晴故意停顿了一下。</p><p>「戒指？」苏小曼配合地问。</p><p>「不是，是两张去马尔代夫的机票！」林雨晴兴奋地拍桌子，「我们下周就出发！」</p><p>苏小曼正要恭喜她，却注意到赵晓柔的脸色变得异常苍白。</p><p>「晓柔，你怎么了？」她关切地问。</p><p>赵晓柔抬起头，嘴唇微微颤抖：「雨晴……你说的那个男朋友，是不是叫周明远？」</p><p>林雨晴的笑容凝固在脸上：「你怎么知道？」</p><p>「因为——」赵晓柔深吸一口气，眼眶已经泛红，「周明远是我的前男友。我们三个月前才分手，而且……我怀孕了。」</p><p>整个咖啡馆仿佛在这一刻静止了。</p>",
  },
  {
    id: "11",
    title: "探险者日志",
    author: "暗夜行者",
    category: "suspense",
    cover: "https://readdy.ai/api/search-image?query=A%20thrilling%20adventure%20manga%20illustration%2C%20explorers%20discovering%20ancient%20ruins%20deep%20in%20a%20jungle%2C%20mysterious%20glowing%20artifacts%2C%20dramatic%20lighting%20through%20dense%20foliage%2C%20action%20and%20mystery%2C%20seinen%20manga%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    description: "一支考古队在亚马逊雨林深处发现了一座失落的古城，却不知道这座古城的秘密，将彻底改变人类文明的认知。",
    rating: 9.1,
    views: 134000,
    chapters: 40,
    updateDate: "2026-08-06",
    tags: ["悬疑", "冒险", "考古"],
    featured: false,
    content: "<p>「博士，你确定这条路线是对的吗？」</p><p>赵明远擦了擦额头上的汗水，抬头看向密不透风的热带雨林树冠。他们已经在这片亚马逊雨林中跋涉了整整七天。</p><p>「根据卫星图像和老猎人的描述，失落之城应该就在前方十公里处。」考古学博士陈教授盯着手中的GPS设备，语气中透着掩饰不住的兴奋。</p><p>突然，走在最前面的向导停下了脚步。</p><p>「教授，你们来看这个。」</p><p>众人围了过去。只见密林深处，隐约露出了一座巨大的石制建筑。藤蔓和苔藓覆盖了大部分表面，但依然可以看到上面精美的浮雕图案。</p><p>「天哪……」陈教授颤抖着手抚摸着浮雕，「这些图案……不属于任何已知的文明。」</p><p>赵明远举起相机，拍下了浮雕的照片。但当他回看照片时，整个人都愣住了。</p><p>照片中，浮雕的底部出现了一行他们之前没有注意到的文字。那不是任何一种人类已知的语言，但不知为何，赵明远竟然能够读懂它的意思——</p><p>「闯入者，将永远留在这里。」</p>",
  },
  {
    id: "12",
    title: "麻辣教师",
    author: "糖果盒子",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20school%20comedy%20manga%20illustration%2C%20a%20young%20enthusiastic%20teacher%20trying%20to%20control%20a%20chaotic%20classroom%20full%20of%20mischievous%20students%2C%20exaggerated%20expressions%2C%20bright%20and%20energetic%20colors%2C%20gag%20manga%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    description: "刚从师范大学毕业的林老师接手了全校最头疼的班级。他的教学方法非同寻常，让这群问题学生心服口服。",
    rating: 8.5,
    views: 76000,
    chapters: 28,
    updateDate: "2026-08-05",
    tags: ["搞笑", "校园", "热血"],
    featured: false,
    content: "<p>「同学们好，我是你们的新班主任，林浩然。」</p><p>讲台上的年轻男人推了推眼镜，对着满教室东倒西歪的学生们露出了一个灿烂的笑容。</p><p>回应他的是一阵此起彼伏的哈欠声。</p><p>「老师，你是新来的吧？我建议你趁早调走。」坐在最后一排的男生翘着二郎腿，「我们班可是出了名的地狱班级，上一任班主任是被我们气哭走的。」</p><p>林浩然依然保持着微笑：「我知道。所以我是自愿来的。」</p><p>全班突然安静了。</p><p>「你们听说过一句话吗？」林浩然拿起粉笔，在黑板上写下了四个大字——以毒攻毒。「我不会用传统的方法来管你们。你们喜欢捣乱，那我们就来比一比，看谁更会捣乱。」</p><p>「什么意思？」翘二郎腿的男生——也就是班上的老大张浩——皱起了眉头。</p><p>「从今天开始，每节课的前十分钟，你们可以随便提问、随便吐槽、随便挑战我。如果我答不上来，这节课你们可以自由活动。但如果我答上来了——」林浩然的眼睛里闪过一道精光，「你们就得乖乖上完整节课。」</p><p>张浩站了起来：「你说的？」</p><p>「我说的。」</p><p>于是，一场前所未有的师生对决开始了。</p>",
  },
];